import script from "./StepPracticeVerify.vue?vue&type=script&setup=true&lang=js"
export * from "./StepPracticeVerify.vue?vue&type=script&setup=true&lang=js"

import "./StepPracticeVerify.vue?vue&type=style&index=0&id=1e83dd98&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e83dd98"]])

export default __exports__